import md5 from 'js-md5';
import { guid } from './tool';
import { getDeviceId } from './device';
import { formatParams, queryString } from './qs';
import { APPID, KEY } from '../origin';

function getOpenAuthParams() {
  return {
    appid: APPID,
    format: 'json',
    v: '2.0',
    sign_method: 'md5',
    requestid: `${getDeviceId()}_${guid()}`,
    timestamp: Math.floor(Date.now() / 1000)
  };
}

function computeSign(authParams) {
  const sorted = formatParams(authParams);
  return md5(`${queryString(sorted)}&key=${KEY}`).toUpperCase();
}

export function md5sign(params = {}) {
  const authParams = getOpenAuthParams();
  return { ...params, ...authParams, sign: computeSign(authParams) };
}

export function getSignedQuery(options = {}) {
  const { params = {}, baseUrl } = options;
  const qs = queryString(md5sign(params));
  if (!baseUrl) return qs;
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${qs}`;
}